import { render, staticRenderFns } from "./PropertyBooleanSimple.vue?vue&type=template&id=729b708e&"
import script from "./PropertyBooleanSimple.vue?vue&type=script&lang=js&"
export * from "./PropertyBooleanSimple.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports